import React from 'react';
import { Link } from 'react-router-dom';
import './TendersHero.css';

// Reusing the same decorative graphic
import graphicImg from '../../assets/images/stats-hero-graphic.png';

const TendersHero = () => {
  return (
    <section className="tenders-hero-section">
      <div className="tenders-hero-content">
        <h1>Access exclusive Notifications</h1>
        <p>
          Get access to global Notifications opportunities and make informed, competitive bids.
        </p>
        <Link to="/signup">
          <button className="book-demo-btn">Book a demo</button>
        </Link>
      </div>
      <div className="tenders-hero-graphic">
        <img src={graphicImg} alt="Tenders and Data Graphic" />
      </div>
    </section>
  );
};

export default TendersHero;